import moment from 'moment-timezone';
import humanFormat from 'human-format';
import { TZ } from '../../../../shared/consts';
import { INPUT_FMT } from '../constants';

const DATE_FMTS = {
  tick: {
    d: 'Do MMM',
    w: 'Do MMM',
    m: 'MMM YY',
  },
  label: {
    d: 'Do MMM, YY',
    w: 'Do MMM, YY',
    m: 'MMM YY',
  },
};

const dateFormatter = ({ granularity, type }) => dateString => {
  const startDate = moment(dateString, INPUT_FMT, TZ);
  const fmt = DATE_FMTS[type][granularity] || DATE_FMTS[type].d;
  if (granularity === 'w') {
    return `${startDate.format(fmt)} - ${startDate.clone().add(6, 'days').format(fmt)}`;
  }
  return startDate.format(fmt);
};

const buildXTickFormatter = granularity => dateFormatter({ granularity, type: 'tick' });
const buildLabelFormatter = granularity => dateFormatter({ granularity, type: 'label' });

const yTickFormatter = d => (d < 1 ? '' : humanFormat(Math.round(d), { decimals: 1, separator: '' }));

export {
  buildLabelFormatter,
  buildXTickFormatter,
  yTickFormatter,
};
